import { http } from '@/app/lib/http/client'

export interface StorePromotionSectionItem {
  id: number
  section_id: number
  name: string
  image_url: string
  call_to_action_url?: string | null
  promotion_id?: number | null
  sort_order: number
  is_active: boolean
  created_at?: string
  updated_at?: string
  file?: File
  preview_url?: string
}

export interface StorePromotionSection {
  id: number
  company_id: number
  name: string
  title?: string | null
  subtitle?: string | null
  is_active: boolean
  starts_at?: string | null
  ends_at?: string | null
  created_at?: string
  updated_at?: string
  items: StorePromotionSectionItem[]
}

export interface Paginator<T> {
  current_page: number
  data: T[]
  from: number
  last_page: number
  per_page: number
  to: number
  total: number
}

export const promotionSectionService = {
  async getSections(params: { page?: number; per_page?: number; name?: string }): Promise<{ data: Paginator<StorePromotionSection> }> {
    const response = await http.get('/ecommerce/promotion-sections', { params })
    return response.data
  },

  async getSection(id: number): Promise<StorePromotionSection> {
    const response = await http.get(`/ecommerce/promotion-sections/${id}`)
    return response.data.data
  },

  async createSection(data: FormData): Promise<StorePromotionSection> {
    const response = await http.post('/ecommerce/promotion-sections', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data.data
  },

  async updateSection(id: number, data: FormData): Promise<StorePromotionSection> {
    data.append('_method', 'PUT')
    const response = await http.post(`/ecommerce/promotion-sections/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data.data
  },

  async deleteSection(id: number): Promise<void> {
    await http.delete(`/ecommerce/promotion-sections/${id}`)
  },

  async toggleSectionStatus(id: number): Promise<void> {
    await http.patch(`/ecommerce/promotion-sections/${id}/status`)
  },
}
